import {Component, Input, OnInit} from '@angular/core';
import {SettingsComponent} from '../settings.component';
import {AppComponent} from '../../app.component';
import {LeftpanelComponent} from '../../leftpanel/leftpanel.component';
import {ConfService} from '../../conf.service';
import {AttributeColumn} from '../dynamic-form-builder/dynamic-form-builder.component';
import {AccountInfoService} from '../../user/account-info.service';
import {interval} from 'rxjs';
import {Router} from '@angular/router';
import {AdminEnvironmentHandlerService} from '../../admin-environment-handler.service';
import {PartnerSettingsService} from '../../partnerSettings/partner-settings.service';

@Component({
  selector: 'app-branding',
  templateUrl: './branding.component.html',
  styleUrls: ['./branding.component.scss']
})
export class BrandingComponent implements OnInit {

  item: any;
  settingsLoading = true;

  partner = localStorage.getItem('partner');
  account = localStorage.getItem('account');

  headerRibbonColor = '';
  pageTitle = '';
  headerTextColor = '';

  devexConfig = {
    headerRibbonColor: '',
    pageTitle: '',
    headerTextColor: ''
  };

  origConfig: any;
  updating = false;

  constructor(private confPost: ConfService,
              public settingComp: SettingsComponent,
              public accountInfoService: AccountInfoService,
              private appComp: AppComponent,
              public platform: LeftpanelComponent,
              public router: Router,
              private adminEnvironmenthandler: AdminEnvironmentHandlerService,
              private partnerSettingsService: PartnerSettingsService) { }

  redirect(route: string) {
    this.router.navigate([route]);
  }

  async setData() {
    this.appComp.currentPageTitle = 'Manage Branding';
    this.appComp.ribbon = 'Branding';
    if (!this.settingComp.item) {
      this.settingComp.setcolumnvalues();
    }

    if (this.platform.settingsData !== null && this.platform.settingsData !== undefined) {
      this.item = this.platform.settingsData['body'][0];
      this.setDevexConfigs();
      this.settingsLoading = false;
    } else {
      await this.confPost.getSettingsV2CRUD(this.partner, this.account, false).subscribe(response => {
        if (response['body'] && response['body'][0]) {
          this.platform.settingsData = response;
          this.item = response['body'][0];
          this.setDevexConfigs();
          this.settingsLoading = false;
        }
      });
    }
  }

  initialize() {
    const partnerSettingsSubscription = interval(500).subscribe((async x => {
      if (this.partnerSettingsService.hasPartnerSettingsDataSet()) {
        partnerSettingsSubscription.unsubscribe();
        let environmentData = this.partnerSettingsService.environment;
        if (!environmentData.name.includes('admin')) {
          this.redirect('/console');
        } else {
          this.setData();
        }
        this.adminEnvironmenthandler.onEnvironmentChange.subscribe(async env => {
          this.partnerSettingsService.changeEnvironment();
          environmentData = this.partnerSettingsService.environment;
          if (!environmentData.name.includes('admin')) {
            this.redirect('/console');
          } else {
            this.setData();
          }
        });
      }
    }));
  }

  ngOnInit() {
    if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
      this.platform.initialisePlatform();
    }

    this.initialize();

  }

  setDevexConfigs() {
    for (const env1 of this.item['environments']) {
      if (env1['name'] === this.partner) {
        const devex = env1['services'].filter(element => element.name === 'Developer Experience');
        for (const config of devex[0]['configurations']) {
          if (config && config !== null && config !== undefined) {
            if (config['name'] === 'Developer Experience') {
              this.devexConfig.pageTitle = config['devex_configurations'] ? config['devex_configurations']['pageTitle'] ? config['devex_configurations']['pageTitle'] : '' : '';
              this.devexConfig.headerRibbonColor = config['devex_configurations'] ? config['devex_configurations']['css_properties'] ? config['devex_configurations']['css_properties']['headerRibbonColor'] ? config['devex_configurations']['css_properties']['headerRibbonColor'] : '' : '' : '';
              this.devexConfig.headerTextColor = config['devex_configurations'] ? config['devex_configurations']['css_properties'] ? config['devex_configurations']['css_properties']['headerTextColor'] ? config['devex_configurations']['css_properties']['headerTextColor'] : '' : '' : '';
              this.origConfig = JSON.parse(JSON.stringify(this.devexConfig));
            }
          }
        }
      }
    }
  }

  patchConfiguration(partner, account, version, entity, id, payload) {
    return new Promise((resolve, reject) => {
      this.platform.patchEntityData(partner, account, version, entity, id, payload).then(resp => {
        resolve('success');
      }, error => {
        reject(error);
      });
    });
  }

  isValidColor(strColor) {
    const s = new Option().style;
    s.color = strColor;
    return s.color !== '';
  }

  updatePartnerDevex() {
    if (JSON.stringify(this.devexConfig) === JSON.stringify(this.origConfig)) {
      this.platform.openSnackBar('There is no new information to update.', 'Error', {
        duration: 4000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
    } else {
      this.updating = true;
      let index = 0;
      for (const env1 of this.item['environments']) {
        if (env1 && env1 !== null && env1 !== undefined) {
          this.confPost.getSettingsV2CRUD(env1['name'], env1['name'], false).subscribe(async response1 => {
            let updateFlag = false;
            if (response1 && response1['body'] && response1.status === 200) {
              for (const env2 of response1['body'][0]['environments']) {
                if (env2 && env2 !== null && env2 !== undefined) {
                  const timeService = env2['services'].filter(element => element.name === 'Developer Experience');
                  if (timeService.length > 0) {
                    for (let i = 0; i < timeService[0]['configurations'].length; i++) {
                      const config = timeService[0]['configurations'][i];
                      if (config && config !== null && config !== undefined) {
                        if (config['name'] === 'default') {
                          if (!timeService[0]['configurations'][i]['devex_configurations']) {
                            timeService[0]['configurations'][i]['devex_configurations'] = {};
                          }
                          if (!timeService[0]['configurations'][i]['devex_configurations']['css_properties']) {
                            timeService[0]['configurations'][i]['devex_configurations']['css_properties'] = {};
                          }
                          timeService[0]['configurations'][i]['devex_configurations']['pageTitle'] = this.devexConfig.pageTitle;
                          timeService[0]['configurations'][i]['devex_configurations']['css_properties']['headerRibbonColor'] = this.isValidColor(this.devexConfig.headerRibbonColor) ? this.devexConfig.headerRibbonColor : '';
                          timeService[0]['configurations'][i]['devex_configurations']['css_properties']['headerTextColor'] = this.isValidColor(this.devexConfig.headerTextColor) ? this.devexConfig.headerTextColor : '';
                          updateFlag = true;
                        }
                      }
                    }
                  }
                }
              }
              if (updateFlag) {
                this.updating = false;
                await this.patchConfiguration('services', 'services', 'v2', 'settings', response1['body'][0]['id'], response1['body'][0]).then(resp => {
                  index += 1;
                  if (index === this.item['environments'].length) {
                      this.updating = false;
                      this.origConfig = JSON.parse(JSON.stringify(this.devexConfig));
                      this.platform.openSnackBar('Configuration saved successfully.', 'Success', {
                        duration: 4000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                      });
                  }
                }, error => {
                  index += 1;
                  this.updating = false;
                  this.platform.openSnackBar('Error while updating configurations for ' + response1['body'][0]['partner'] + '. Please contact administrator.', 'Error', {
                    duration: 4000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                  });
                });
              } else {
                this.updating = false;
                index += 1;
              }
            }
          }, error => {
            this.updating = false;
            this.platform.openSnackBar('Unable to update configurations. Please try again later.', 'Error', {
              duration: 4000,
              verticalPosition: 'top',
              horizontalPosition: 'center'
            });
          });
        } else {
          this.updating = false;
          this.platform.openSnackBar('Unable to update configurations. Please try again later.', 'Error', {
            duration: 4000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
          });
        }
      }
    }
  }

}
